import { render } from "./HotPlacePage.vue?vue&type=template&id=6ea3c5a2"
import script from "./HotPlacePage.vue?vue&type=script&lang=js"
export * from "./HotPlacePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__